import {
  getRedirectExternalIdStorage,
  removeRedirectExternalIdStorage,
} from './redirectExternalIdStorage'
import { sendEventToGA } from './sendEventToGA'

export const sendEventsForRedirectExternalId = ({
  isGenericUser = false,
  slug = null,
}: {
  isGenericUser: boolean
  slug: string | null
}) => {
  const redirectByExternalId = getRedirectExternalIdStorage()

  if (!redirectByExternalId) {
    return
  }

  sendEventToGA({
    type: isGenericUser ? 'REDIRECT_ERROR_RE_HAS_NO_MLD' : 'REDIRECT_SUCCESS',
    externalId: redirectByExternalId.SESSION_STORAGE_EXTERNAL_ID_KEY,
    origin: redirectByExternalId.SESSION_STORAGE_ORIGIN_KEY,
    slug: slug,
  })

  removeRedirectExternalIdStorage()
}
